export const GoogleIcon = () => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
			fill="#4285F4"
		/>
		<path
			d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
			fill="#34A853"
		/>
		<path
			d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
			fill="#FBBC05"
		/>
		<path
			d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
			fill="#EA4335"
		/>
	</svg>
);

export const FacebookIcon = () => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M24 12.073C24 5.405 18.627 0 12 0S0 5.405 0 12.073C0 18.1 4.388 23.094 10.125 24v-8.437H7.078v-3.49h3.047v-2.66c0-3.025 1.792-4.697 4.533-4.697 1.312 0 2.686.236 2.686.236v2.971h-1.513c-1.491 0-1.956.93-1.956 1.886v2.264h3.328l-.532 3.49h-2.796V24C19.612 23.094 24 18.1 24 12.073z"
			fill="#1877F2"
		/>
	</svg>
);

export const FooterIcon = () => (
	<svg width="106" height="32" viewBox="0 0 106 32" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M7 11.7754L5.66802 10.8354L0 14.8354L5.66802 18.8354L7 17.8954L2.67341 14.8354L7 11.7754Z"
			fill="#EDF2F7"
			fillOpacity="0.3"
		/>
		<path
			d="M100.332 10.8354L99 11.7754L103.327 14.8354L99 17.8954L100.332 18.8354L106 14.8354L100.332 10.8354Z"
			fill="#CBD5E0"
		/>
		<circle cx="54" cy="15.8354" r="4" fill="#D9D9D9" />
		<circle cx="29.0102" cy="15.5176" r="1.85789" fill="#EDF2F7" fillOpacity="0.3" />
		<circle cx="79.6001" cy="15.5176" r="1.85789" fill="#EDF2F7" fillOpacity="0.3" />
		<mask id="path-6-inside-1_641_6001" fill="white">
			<path d="M45.6115 8.54037C43.9578 10.6007 43.0896 13.1814 43.1617 15.8224C43.2339 18.4633 44.2416 20.9928 46.0053 22.9598C47.769 24.9268 50.174 26.2034 52.7914 26.5621C55.4089 26.9208 58.0687 26.3382 60.2965 24.9182L58.7252 22.4529C57.0816 23.5005 55.1194 23.9304 53.1884 23.6657C51.2573 23.4011 49.4831 22.4593 48.1819 21.0081C46.8808 19.557 46.1373 17.6909 46.0841 15.7425C46.0309 13.7942 46.6714 11.8903 47.8914 10.3703L45.6115 8.54037Z" />
		</mask>
		<path
			d="M45.6115 8.54037C43.9578 10.6007 43.0896 13.1814 43.1617 15.8224C43.2339 18.4633 44.2416 20.9928 46.0053 22.9598C47.769 24.9268 50.174 26.2034 52.7914 26.5621C55.4089 26.9208 58.0687 26.3382 60.2965 24.9182L58.7252 22.4529C57.0816 23.5005 55.1194 23.9304 53.1884 23.6657C51.2573 23.4011 49.4831 22.4593 48.1819 21.0081C46.8808 19.557 46.1373 17.6909 46.0841 15.7425C46.0309 13.7942 46.6714 11.8903 47.8914 10.3703L45.6115 8.54037Z"
			stroke="#D9D9D9"
			strokeWidth="4"
			mask="url(#path-6-inside-1_641_6001)"
		/>
	</svg>
);
